/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Error_Certification_Badge_In_UseInputs */

const vi_error_certification_badge_in_use = /** @type {(inputs: Error_Certification_Badge_In_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logo đang dùng trên ${i?.count} sản phẩm nên không xoá được — tắt Hiện trong trình thiết kế để ẩn.`)
};

/**

* @param {Error_Certification_Badge_In_UseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_certification_badge_in_use = /** @type {((inputs: Error_Certification_Badge_In_UseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Certification_Badge_In_UseInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_certification_badge_in_use(inputs)
});